import React from "react";
import ReactDOM from "react-dom";
import axe from "@axe-core/react";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import TagManager from "react-gtm-module";
import { initAwsRum } from "./services/AwsRum";
import * as Sentry from "@sentry/react";

// Master switch: Sentry only initializes when REACT_APP_SENTRY_ENABLED === "true".
// When off, init is skipped entirely and every other Sentry.* call is a safe no-op.
if (process.env.REACT_APP_SENTRY_ENABLED === "true") {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    environment: process.env.REACT_APP_ENV || "local",
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
        networkDetailAllowUrls: [
          process.env.REACT_APP_BACKEND_API || "http://localhost:3001",
        ],
      }),
      Sentry.consoleLoggingIntegration({ levels: ["log", "warn", "error"] }),
    ],
    // Attach sentry-trace + baggage headers to backend calls so a single trace spans frontend → backend.
    tracePropagationTargets: [
      process.env.REACT_APP_BACKEND_API || "http://localhost:3001",
      /^\//,
    ],
    tracesSampleRate: Number(process.env.REACT_APP_SENTRY_TRACES_SAMPLE_RATE ?? 0.2),
    replaysSessionSampleRate: Number(
      process.env.REACT_APP_SENTRY_REPLAYS_SESSION_SAMPLE_RATE ?? 0.2
    ),
    replaysOnErrorSampleRate: Number(
      process.env.REACT_APP_SENTRY_REPLAYS_ON_ERROR_SAMPLE_RATE ?? 1.0
    ),
    enableLogs: true,
  });
}

initAwsRum();

const tagManagerArgs = {
  gtmId: process.env.REACT_APP_GTM_ID || "GTM-W334XCD",
};

TagManager.initialize(tagManagerArgs);

// This condtion will by default run the axe-core plugin to run on local developemnt build
if (process.env.NODE_ENV !== "production") {
  axe(React, ReactDOM, 1000);
}

// disable console.log in production
if (process.env.REACT_APP_ENV === "prod") {
  console.log = () => {};
}

// Added this condition to run axe-core plugin to run on staging and develop env
if (
  process.env.REACT_APP_DEPLOYMENT_ENV === "staging" ||
  process.env.REACT_APP_DEPLOYMENT_ENV === "develop"
) {
  axe(React, ReactDOM, 1000);
}

ReactDOM.render(<App />, document.getElementById("root"));

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
